module.exports = __webpack_public_path__ + "img/Pacientes.82cc5d5f.svg";